import { render } from "./AdditionalPages.vue?vue&type=template&id=a7037968&scoped=true"
import script from "./AdditionalPages.vue?vue&type=script&lang=js"
export * from "./AdditionalPages.vue?vue&type=script&lang=js"

import "./AdditionalPages.vue?vue&type=style&index=0&id=a7037968&scoped=true&lang=css"

import exportComponent from "/builds/qes-dev/mirror-qes-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7037968"]])

export default __exports__